import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Button, Container, Modal, Table } from 'react-bootstrap';
import { formatDateToFinnishDisplay } from '../../common/utils/dateUtils';
import {
  addStatusToast,
  clearStatusToasts,
  Loader,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  AzureFileItemDto,
  downloadFakeWintimeFolderAsync,
  downloadFilesFromWintimeFolderAsync,
  downloadSelectedWintimeBackupFilesAsync,
  generateWintimeFilesAsync,
  listWintimeBackupFilesAsync,
  selectWintimeLoadingStatusLoadingStatus,
} from '../Users/identityUsersSlice';

function WintimeTransfer() {
  const dispatch = useAppDispatch();
  const wintimeLoadingStatus = useAppSelector(
    selectWintimeLoadingStatusLoadingStatus,
  );
  useEffect(() => {}, []);
  const [showLoader, setshowLoader] = useState<boolean>(false);
  const [latesDate, setLatesDate] = useState<Date>(null);
  // Local state to hold listed backup files and errors
  const [backupFiles, setBackupFiles] = useState<AzureFileItemDto[]>([]);
  const [listError, setListError] = useState<string | null>(null);
  const [isListing, setIsListing] = useState<boolean>(false);
  useEffect(() => {}, [latesDate]);
  const initFetch = useCallback(() => {
    dispatch(downloadFakeWintimeFolderAsync())
      .then(responseDate => {
        if (
          responseDate.meta.requestStatus !== 'rejected' &&
          responseDate.payload.latestModified !== null
        ) {
          setLatesDate(
            responseDate.payload.latestModified
              ? new Date(responseDate.payload.latestModified)
              : null,
          );
        } else {
          setLatesDate(null);
        }
      })
      .catch(error => {
        console.error('error', error);
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(clearStatusToasts());
  }, [dispatch]);

  const [wintimeSuccess, setWintimeSuccess] = useState<boolean>(false);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  useEffect(() => {
    initFetch();
  }, [initFetch]);
  const downloadWintime = (): void => {
    dispatch(clearStatusToasts());
    dispatch(downloadFilesFromWintimeFolderAsync())
      .then(action => {
        if (downloadFilesFromWintimeFolderAsync.fulfilled.match(action)) {
          const { blobUrl, fileName } = action.payload;
          const link = document.createElement('a');
          link.href = blobUrl;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } else {
          dispatch(
            addStatusToast({
              Title: 'Virhe',
              IsFailed: true,
              Message: `Wintime aineiston lataus ei onnistunut:${action.error.message}`,
            }),
          );
        }
      })
      .catch(error => {
        dispatch(
          addStatusToast({
            Title: 'Virhe',
            IsFailed: true,
            Message: `Wintime aineiston lataus ei onnistunut:${error.message}`,
          }),
        );
      });
  };
  const handleReturn = (): void => {
    setShowConfirmation(false);
  };

  const handleShowDialog = (): void => {
    setShowConfirmation(true);
  };
  const listWintimeBackups = (): void => {
    setIsListing(true);
    setListError(null);
    dispatch(listWintimeBackupFilesAsync())
      .then(action => {
        if (listWintimeBackupFilesAsync.fulfilled.match(action)) {
          setBackupFiles(action.payload ?? []);
        } else {
          setListError('Listing failed');
          setBackupFiles([]);
        }
      })
      .catch(err => {
        setListError(err?.message ?? 'Listing failed');
        setBackupFiles([]);
      })
      .finally(() => setIsListing(false));
  };

  const downloadSelectedBackup = (name: string): void => {
    dispatch(clearStatusToasts());
    dispatch(downloadSelectedWintimeBackupFilesAsync([name]))
      .then(action => {
        if (downloadSelectedWintimeBackupFilesAsync.fulfilled.match(action)) {
          const { blobUrl, fileName } = action.payload as {
            blobUrl: string;
            fileName: string;
          };
          const link = document.createElement('a');
          link.href = blobUrl;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.parentNode?.removeChild(link);
        } else {
          dispatch(
            addStatusToast({
              Title: 'Virhe',
              IsFailed: true,
              Message: `Varmuuskopion lataus ei onnistunut: ${action.error?.message ?? ''}`,
            }),
          );
        }
      })
      .catch(error => {
        dispatch(
          addStatusToast({
            Title: 'Virhe',
            IsFailed: true,
            Message: `Varmuuskopion lataus ei onnistunut: ${error?.message ?? ''}`,
          }),
        );
      });
  };

  const generateAndSendToAzureWintime = (): void => {
    dispatch(clearStatusToasts());
    setshowLoader(true);
    dispatch(generateWintimeFilesAsync())
      .then(action => {
        if (
          !generateWintimeFilesAsync.fulfilled.match(action) ||
          action.payload === false
        ) {
          setLatesDate(null);
          dispatch(
            addStatusToast({
              Title: 'Virhe',
              IsFailed: true,
              Message:
                action.payload?.message ||
                'Wintime aineiston luonti ei onnistunut',
            }),
          );
          setshowLoader(false);
          setShowConfirmation(false);
        } else {
          setLatesDate(null);
          dispatch(
            addStatusToast({
              Title: 'Onnistui',
              IsFailed: false,
              Message:
                action.payload?.message || 'Wintime aineiston luonti valmis',
            }),
          );
          dispatch(downloadFakeWintimeFolderAsync()).then(responseDate => {
            if (responseDate.payload) {
              setLatesDate(
                responseDate.payload.latestModified
                  ? new Date(responseDate.payload.latestModified)
                  : null,
              );
            }
          });
          setshowLoader(false);
          setShowConfirmation(false);
        }
        // If fulfilled, we wait for SignalR notification to complete processing and update UI.
      })
      .catch(error => {
        setshowLoader(false);
        setShowConfirmation(false);
        console.error('error2', error);
      });
  };
  return (
    <>
      <Helmet>
        <title>Wintime aineistot</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Kirjanpitoaineisto']}
          Title="Wintime aineiston luonti ja siirto"
        />
        {!showLoader && (
          <div>
            <Button
              onClick={handleShowDialog}
              size="sm"
              variant="outline-blue"
              className="px-16 me-2"
              disabled={showLoader}
            >
              Luo wintime aineisto
            </Button>
            <Button
              onClick={downloadWintime}
              size="sm"
              variant="outline-blue"
              className="px-16 me-2"
            >
              Lataa wintime aineisto Zip tiedostona
            </Button>
            <Button
              onClick={listWintimeBackups}
              size="sm"
              variant="outline-blue"
              className="px-16"
              disabled={isListing}
            >
              {isListing ? 'Listataan...' : 'Listaa Wintime varmuuskopiot'}
            </Button>
            <div className="mt-2">
              Viimeisin siirtopäivä:{' '}
              {latesDate ? (formatDateToFinnishDisplay(latesDate) ?? '') : ''}
            </div>
          </div>
        )}

        {listError && <div className="text-danger mt-2">{listError}</div>}
        {backupFiles?.length > 0 && (
          <div className="mt-3">
            <strong>Varmuuskopiotiedostot:</strong>
            <Table striped bordered hover size="sm" className="mt-2">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Kansio</th>
                  <th>Luontiaika</th>
                  <th>Toiminnot</th>
                </tr>
              </thead>
              <tbody>
                {backupFiles.map((item, idx) => (
                  <tr key={item.name}>
                    <td style={{ width: 60 }}>{idx + 1}</td>
                    <td className="font-monospace">{item.name}</td>
                    <td className="font-monospace">
                      {formatDateToFinnishDisplay(new Date(item.lastModified))}
                    </td>
                    <td style={{ width: 260 }}>
                      <Button
                        onClick={() => downloadSelectedBackup(item.name)}
                        size="sm"
                        variant="outline-blue"
                        className="px-16"
                        disabled={isListing}
                      >
                        Lataa Zip tiedostona
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
        <Modal
          show={showConfirmation}
          onHide={handleReturn}
          centered
          size="sm"
          backdrop={showLoader ? 'static' : true}
          style={{
            position: 'fixed',
            zIndex: '1080!important',
            backgroundColor: '#aaa',
          }}
        >
          <Loader IsLoading={showLoader} />
          <Modal.Header>
            <Modal.Title>Vahvista toiminto</Modal.Title>
          </Modal.Header>
          <Modal.Body>Luodaanko wintime aineisto ?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleReturn}
              disabled={showLoader}
            >
              Peruuta
            </Button>
            <Button
              variant="primary"
              onClick={generateAndSendToAzureWintime}
              disabled={showLoader}
            >
              Ok, luo aineisto
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
}

export default WintimeTransfer;
